import { Alert } from "../../Data/Alert";
import {IRuleViolation} from "../../Interfaces/Application/IApplicationQuote";
import {BrowserNotification} from "@amsanalytics/react-shared-library/build/Models/BrowserNotification";

export const SHOW_ALERT = 'SHOW_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const UPDATE_LEASE_QUOTE_ERRORS_SUCCESS = 'UPDATE_LEASE_QUOTE_ERRORS_SUCCESS';
export const UPDATE_LEASE_QUOTE_CALC_ERRORS_SUCCESS = 'UPDATE_LEASE_QUOTE_CALC_ERRORS_SUCCESS';
export const UPDATE_FINANCE_QUOTE_ERRORS_SUCCESS = 'UPDATE_FINANCE_QUOTE_ERRORS_SUCCESS';
export const UPDATE_FINANCE_QUOTE_CALC_ERRORS_SUCCESS = 'UPDATE_FINANCE_QUOTE_CALC_ERRORS_SUCCESS';
export const LOAD_APPLICATION_NOTIFICATIONS = 'LOAD_APPLICATION_NOTIFICATIONS';
export const LOAD_APPLICATION_NOTIFICATIONS_SUCCESS = "LOAD_APPLICATION_NOTIFICATIONS_SUCCESS";
export const UPDATE_SINGLE_APPLICATION_NOTIFICATION = "UPDATE_SINGLE_APPLICATION_NOTIFICATION";
export const UPDATE_MULTIPLE_APPLICATION_NOTIFICATIONS = "UPDATE_MULTIPLE_APPLICATION_NOTIFICATIONS";
export const UPDATE_APPLICATION_NOTIFICATIONS_SUCCESS = "UPDATE_APPLICATION_NOTIFICATIONS_SUCCESS";



export interface UpdateLeaseQuoteErrorsSuccessAction {
  type: typeof UPDATE_LEASE_QUOTE_ERRORS_SUCCESS;
  payload: { leaseQuoteErrors: IRuleViolation[] };
}
export const updateLeaseQuoteErrorsSuccess = (leaseQuoteErrors: IRuleViolation[]): UpdateLeaseQuoteErrorsSuccessAction => {
  return {
    type: UPDATE_LEASE_QUOTE_ERRORS_SUCCESS,
    payload: { leaseQuoteErrors }
  };
}

export interface UpdateLeaseQuoteCalcErrorsSuccessAction {
  type: typeof UPDATE_LEASE_QUOTE_CALC_ERRORS_SUCCESS;
  payload: { leaseQuoteCalcErrors: string[] };
}
export const updateLeaseQuoteCalcErrorsSuccess = (leaseQuoteCalcErrors: string[]): UpdateLeaseQuoteCalcErrorsSuccessAction => {
  return {
    type: UPDATE_LEASE_QUOTE_CALC_ERRORS_SUCCESS,
    payload: { leaseQuoteCalcErrors }
  };
}



export interface UpdateFinanceQuoteErrorsSuccessAction {
    type: typeof UPDATE_FINANCE_QUOTE_ERRORS_SUCCESS;
    payload: { financeQuoteErrors: IRuleViolation[] };
}
export const updateFinanceQuoteErrorsSuccess = (financeQuoteErrors: IRuleViolation[]): UpdateFinanceQuoteErrorsSuccessAction => {
    return {
        type: UPDATE_FINANCE_QUOTE_ERRORS_SUCCESS,
        payload: { financeQuoteErrors }
    };
}

export interface UpdateFinanceQuoteCalcErrorsSuccessAction {
    type: typeof UPDATE_FINANCE_QUOTE_CALC_ERRORS_SUCCESS;
    payload: { financeQuoteCalcErrors: string[] };
}
export const updateFinanceQuoteCalcErrorsSuccess = (financeQuoteCalcErrors: string[]): UpdateFinanceQuoteCalcErrorsSuccessAction => {
    return {
        type: UPDATE_FINANCE_QUOTE_CALC_ERRORS_SUCCESS,
        payload: { financeQuoteCalcErrors }
    };
}

export interface LoadApplicationNotificationsAction {
    type: typeof LOAD_APPLICATION_NOTIFICATIONS;
}
export const loadApplicationNotifications = (): LoadApplicationNotificationsAction => {
    return {
        type: LOAD_APPLICATION_NOTIFICATIONS
    };
}

export interface LoadApplicationNotificationsSuccessAction {
    type: typeof LOAD_APPLICATION_NOTIFICATIONS_SUCCESS;
    payload: { browserNotifications: BrowserNotification[] };
}
export const loadApplicationNotificationsSuccess = (browserNotifications: BrowserNotification[]): LoadApplicationNotificationsSuccessAction => {
    return {
        type: LOAD_APPLICATION_NOTIFICATIONS_SUCCESS,
        payload: { browserNotifications }
    };
}

export interface UpdateSingleApplicationNotificationAction {
    type: typeof UPDATE_SINGLE_APPLICATION_NOTIFICATION;
    payload: { applicationNotificationId: string };
}
export const updateSingleApplicationNotification = (applicationNotificationId: string): UpdateSingleApplicationNotificationAction => {
    return {
        type: UPDATE_SINGLE_APPLICATION_NOTIFICATION,
        payload: { applicationNotificationId }
    };
}

export interface UpdateMultipleApplicationNotificationsAction {
    type: typeof UPDATE_MULTIPLE_APPLICATION_NOTIFICATIONS;
    payload: { applicationNotificationIds: string[] }
}
export const updateMultipleApplicationNotifications = (applicationNotificationIds: string[]): UpdateMultipleApplicationNotificationsAction => {
    return {
        type: UPDATE_MULTIPLE_APPLICATION_NOTIFICATIONS,
        payload: { applicationNotificationIds }
    };
}

export interface UpdateApplicationNotificationsSuccessAction {
    type: typeof UPDATE_APPLICATION_NOTIFICATIONS_SUCCESS;
    payload: { browserNotifications: BrowserNotification[] };
}
export const updateApplicationNotificationsSuccess = (browserNotifications: BrowserNotification[]): UpdateApplicationNotificationsSuccessAction => {
    return {
        type: UPDATE_APPLICATION_NOTIFICATIONS_SUCCESS,
        payload: { browserNotifications }
    };
}

/************************  Begin Alert    ******************************/

// Show Alert
export interface ShowAlertAction {
  type: typeof SHOW_ALERT;
  payload: { notification: Alert };
}
export const showAlert = (notification: Alert): ShowAlertAction => {
  return {
    type: SHOW_ALERT,
    payload: { notification }
  };
}

// Remove Alert
export interface RemoveAlertAction {
  type: typeof REMOVE_ALERT;
  payload: { notificationId: string };
}
export const removeAlert = (notificationId: string): RemoveAlertAction => {
  return {
    type: REMOVE_ALERT,
    payload: { notificationId }
  };
}

/************************   End Alert    ******************************/

export type NotificationAction =
  UpdateLeaseQuoteErrorsSuccessAction
  | UpdateLeaseQuoteCalcErrorsSuccessAction
  | UpdateFinanceQuoteErrorsSuccessAction
  | UpdateFinanceQuoteCalcErrorsSuccessAction
  | LoadApplicationNotificationsAction
  | LoadApplicationNotificationsSuccessAction
  | UpdateSingleApplicationNotificationAction
  | UpdateMultipleApplicationNotificationsAction
  | UpdateApplicationNotificationsSuccessAction
  | ShowAlertAction
  | RemoveAlertAction;
